const { Criteria } = Shopware.Data;

export default {
    template: `
<sw-page class="riccardo-store-list">
    <template #smart-bar-header><h2>Filialen <span v-if="!isLoading">({{ total }})</span></h2></template>
    <template #smart-bar-actions>
        <sw-button variant="primary" :router-link="{ name: 'riccardo.store.create' }">Filiale anlegen</sw-button>
    </template>
    <template #content>
        <sw-entity-listing v-if="stores" :items="stores" :repository="storeRepository" :columns="columns" :is-loading="isLoading" :show-selection="false" detail-route="riccardo.store.detail" @update-records="getList">
            <template #column-active="{ item }">
                <sw-icon :name="item.active ? 'regular-checkmark-xs' : 'regular-times-s'" :color="item.active ? '#37d046' : '#de294c'" small />
            </template>
            <template #column-openingHours="{ item }">{{ (item.openingHours || []).filter(h => !h.closed).length }} Tage geöffnet</template>
        </sw-entity-listing>
    </template>
</sw-page>`,

    inject: ['repositoryFactory'],

    data() {
        return { stores: null, isLoading: false, total: 0 };
    },

    computed: {
        storeRepository() {
            return this.repositoryFactory.create('riccardo_store');
        },
        columns() {
            return [
                { property: 'active', label: 'Aktiv', width: '80px', align: 'center' },
                { property: 'name', label: 'Name', routerLink: 'riccardo.store.detail', primary: true },
                { property: 'street', label: 'Straße' },
                { property: 'zip', label: 'PLZ', width: '90px' },
                { property: 'city', label: 'Ort' },
                { property: 'phone', label: 'Telefon' },
                { property: 'openingHours', label: 'Öffnungszeiten' },
            ];
        },
    },

    created() {
        this.getList();
    },

    methods: {
        getList() {
            this.isLoading = true;
            const criteria = new Criteria(1, 100);
            criteria.addSorting(Criteria.sort('position', 'ASC'));
            criteria.addSorting(Criteria.sort('city', 'ASC'));
            return this.storeRepository.search(criteria).then((result) => {
                this.stores = result;
                this.total = result.total;
            }).finally(() => { this.isLoading = false; });
        },
    },
};
